var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCostsheetError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 66.2051L27.5 69.3301L21.25 66.2051L15 69.3301V6.83008L21.25 9.95508L27.5 6.83008L33.75 9.95508L40 6.83008L46.25 9.95508L52.5 6.83008L58.75 9.95508L65 6.83008V39.6238",
    stroke: "#5D5FEF",
    strokeWidth: 2.92964,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1602 22.9004H49.1602",
    stroke: "#5D5FEF",
    strokeWidth: 2.92964,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1602 30.8242H36.6564",
    stroke: "#5D5FEF",
    strokeWidth: 2.92964,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9922 50.1152V57.4251",
    stroke: "#5D5FEF",
    strokeWidth: 2.92964,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9922 64.75H54.0076",
    stroke: "#5D5FEF",
    strokeWidth: 3.76284,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.0014,
    cy: 57.4331,
    r: 19.353,
    fill: "#5D5FEF",
    fillOpacity: 0.1,
    stroke: "#5D5FEF",
    strokeWidth: 2.92964
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostsheetError);
export default __webpack_public_path__ + "static/media/costsheetError.bf839acf75b66e433916078fee064dfe.svg";
export { ForwardRef as ReactComponent };